import { render, staticRenderFns } from "./Redness.vue?vue&type=template&id=19883278"
import script from "./Redness.vue?vue&type=script&lang=js"
export * from "./Redness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports